import './vimeoPlayer.scss';
import { useIntersectionObserver } from '@rocketmakers/armstrong';
import * as React from 'react';
import Measure from 'react-measure';
export const VimeoPlayer = ({ id }) => {
    const [loaded, setLoaded] = React.useState(true);
    const ref = React.useRef(null);
    useIntersectionObserver(ref, (isIntersecting, __, io) => {
        if (isIntersecting) {
            io.disconnect();
            setLoaded(true);
        }
    }, { rootMargin: '200px' });
    return (<Measure>
      {({ measureRef, contentRect }) => (<div className="vimeo-wrapper-wrapper" ref={measureRef}>
          <div className="vimeo-wrapper" ref={ref}>
            {loaded && <iframe src={`https://player.vimeo.com/video/${id}?playsinline=0`} width={contentRect?.entry?.width} allowFullScreen/>}
            
          </div>
        </div>)}
    </Measure>);
};
